export default __webpack_public_path__ + "static/media/star_rating.f4293801.svg";